import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { isTokenExpire } from "../utils/token";
import {
  Bars3Icon,
  ChartBarSquareIcon,
  BuildingLibraryIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ArrowLeftStartOnRectangleIcon,
  // QueueListIcon,
  UserGroupIcon,
  // BuildingStorefrontIcon,
  // MapPinIcon,
  ClipboardDocumentCheckIcon,
  Cog8ToothIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { COLOR_AZUL_MAIN } from "../utils/const/colors-const";
import { STRING_FALSE, STRING_SIDEBAR_EXPANDED, STRING_TRUE, STRING_VERSION } from "../utils/const/string-const";
import { useTranslation } from "react-i18next";
import LayoutHeader from "./layout-header";
// import { UserIcon } from "lucide-react";
import { obtenerInfoUsuario } from "../api/autenticacion";

const getSideBarStatus = () => {
  try {
    const sideBar = localStorage.getItem(STRING_SIDEBAR_EXPANDED);
    if (sideBar !== null) {
      if (sideBar === STRING_FALSE) {
        return false;
      }
      if (sideBar === STRING_TRUE) {
        return true;
      }
    }
    return false;
  } catch (err) {
    return false;
  }
}

function Layout({ children }) {
  const { t } = useTranslation();
  const [expireToken, setExpireToken] = useState(true);
  const [expandedMenus, setExpandedMenus] = useState({});
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(getSideBarStatus());
  const history = useHistory();
  const location = useLocation();
  const [sideBarColor, setSideBarColor] = useState(COLOR_AZUL_MAIN);
  const [userInfo, setUserInfo] = useState(null);

  const sidebarNavigation = [
    {
      name: t("menu_dashboard"),
      href: "/dashboard",
      icon: ChartBarSquareIcon,
    },
    {
      name: "Checklist",
      href: "/checklist",
      icon: ClipboardDocumentCheckIcon,
    },
    {
      name: t("menu_usuarios"),
      href: "/usuario",
      icon: UserGroupIcon,
    },
    {
      name: t("menu_configuracion"),
      href: "/configuracion",
      icon: Cog8ToothIcon,
    },
    {
      name: t("menu_reportes"),
      href: "/reportes",
      icon: DocumentTextIcon,
    },
    {
      name: t("menu_administracion"),
      href: "/administracion",
      icon: BuildingLibraryIcon,
      subMenu: [
        { name: t("menu_personal_transportar"), href: "/administracion/listar-personal-transportar" },
        { name: t("menu_ruta"), href: "/administracion/listar-ruta" },
        { name: t("menu_persona"), href: "/administracion/listar-personas" },
        { name: t("menu_riesgo"), href: "/administracion/listar-riesgo" },
        { name: t("menu_turno"), href: "/administracion/listar-turno" },
        { name: t("menu_estado_viaje"), href: "/administracion/listar-estado-viaje" },
      ],
    },
    {
      name: t("menu_salir"),
      href: "/salir",
      icon: ArrowLeftStartOnRectangleIcon,
    },
  ];

  const nextPage = (page) => {
    try {
      history.push(`${page}`);
    } catch (err) {
      console.log("nextPage err");
      console.log(err);
    }
  };

  useEffect(() => {
    const sideBar = localStorage.getItem(STRING_SIDEBAR_EXPANDED);
    // console.log('sideBar');
    // console.log(sideBar);
    // console.log(typeof sideBar);
    if (sideBar !== null) {
      if (sideBar === STRING_FALSE) {
        // console.log('side bar false');
        setIsSidebarExpanded(false);
      }
      if (sideBar === STRING_TRUE) {
        // console.log('side bar true');
        setIsSidebarExpanded(true);
      }
    }
    const resp = isTokenExpire();
    if (resp) {
      nextPage("/login");
    } else {
      setExpireToken(false);
    }
    obtenerUsuarioWeb();
  }, []);

  const obtenerUsuarioWeb = async () => {
    try {
      const response = await obtenerInfoUsuario();
      // console.log("response");
      // console.log(response);
      setUserInfo(response);
    } catch (error) {
      console.log("obtenerUsuarioWeb error");
    }
  };

  if (expireToken) {
    return <div></div>;
  }

  const handleToggleMenu = (name) => {
    setExpandedMenus((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleToggleSidebar = () => {
    localStorage.setItem(STRING_SIDEBAR_EXPANDED, !isSidebarExpanded);
    setIsSidebarExpanded(prevState => !prevState);
  };

  if (expireToken) {
    return <div></div>;
  }

  const isCurrentPage = (href, subMenu) => {
    if (subMenu) {
      return subMenu.some(sub => location.pathname === sub.href);
    }
    return location.pathname === href;
  };

  const handleNavigate = (href) => {
    // console.log('handleNavigate');
    // console.log(href);
    history.push(href);
    setIsMobileMenuOpen(false);

  };

  const renderMenuItem = (item, index) => {
    const isExpanded = expandedMenus[item.name];
    const isCurrent = isCurrentPage(item.href, item.subMenu);
    const hasSubMenu = item.subMenu && item.subMenu.length > 0;

    return (
      <div key={index} className="mb-1">
        <div
          className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-all ${isCurrent
            ? "bg-blue-700 text-white"
            : "text-blue-100 hover:bg-blue-700 hover:text-white"
            }`}
          onClick={() => {
            if (hasSubMenu) {
              handleToggleMenu(item.name);
            } else {
              handleNavigate(item.href);
            }
          }}
          title={item.name}
        >
          <div className="flex items-center gap-3 flex-1 min-w-0">
            {item.icon && <item.icon className="h-5 w-5 flex-shrink-0" />}
            {isSidebarExpanded && (
              <span className="font-medium truncate">{item.name}</span>
            )}
          </div>
          {hasSubMenu && isSidebarExpanded && (
            <div className="flex-shrink-0 ml-2">
              {isExpanded ? (
                <ChevronDownIcon className="h-4 w-4" />
              ) : (
                <ChevronRightIcon className="h-4 w-4" />
              )}
            </div>
          )}
        </div>

        {/* SubMenu */}
        {hasSubMenu && isExpanded && isSidebarExpanded && (
          <div className="ml-8 mt-1 space-y-1">
            {item.subMenu.map((subItem, subIndex) => (
              <div
                key={subIndex}
                className={`p-2 pl-4 rounded-lg cursor-pointer text-sm transition-all ${location.pathname === subItem.href
                  ? "bg-blue-700 text-white"
                  : "text-blue-100 hover:bg-blue-700 hover:text-white"
                  }`}
                onClick={() => handleNavigate(subItem.href)}
              >
                {subItem.name}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Mobile Menu Toggle Button */}
      <button
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-blue-600 text-white rounded-lg shadow-lg"
      >
        <Bars3Icon className="h-6 w-6" />
      </button>

      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-40 flex flex-col h-full transition-all duration-300 ${isSidebarExpanded ? "w-64" : "w-20"
          } ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
        style={{ backgroundColor: sideBarColor }}
      >
        {/* Logo & Toggle */}
        <div className="flex items-center justify-between p-4 border-b border-blue-500">
          <div className="flex items-center gap-3 min-w-0">
            <div className="flex-shrink-0 w-10 h-8 bg-white rounded-lg flex items-center justify-center">
              <span className="text-blue-600 font-bold text-lg">CL</span>
            </div>
            {isSidebarExpanded && (
              <span className="text-xl font-bold text-white truncate">{("Checklist")}</span>
            )}
          </div>
          <button
            onClick={handleToggleSidebar}
            className="hidden lg:block text-white hover:bg-blue-700 p-1 rounded transition-colors"
          >
            <ChevronRightIcon
              className={`h-5 w-5 transition-transform ${isSidebarExpanded ? "rotate-180" : ""
                }`}
            />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 overflow-y-auto">
          {sidebarNavigation.map((item, index) => renderMenuItem(item, index))}
        </nav>

        {/* Footer Version */}
        <div className="p-4 border-t border-blue-500">
          {isSidebarExpanded && (
            <p className="text-xs text-blue-200 text-center">
              Version {STRING_VERSION}
            </p>
          )}
        </div>
      </aside>

      {/* Content Area */}
      {/* <main className="flex-1 min-h-screen bg-gray-50 lg:ml-0">
        {children}
      </main> */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <LayoutHeader userInfo={userInfo} />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto ">
          {children}
        </main>
      </div>
    </div>
  );
}
export default Layout;
